// Course name to short code mapping
// Source: course_packages.course_short_code
export const COURSE_SHORT_CODES = {
  'DIPLOMA IN CIVIL QA/QC ENGINEERING': 'CP',
  'DIPOLAM IN PIPING ENGINEERING': 'MP',
  'MP+PGDCEM-M': 'MP+PGDCEM-M',
  'Professional Diploma in Civil BIM Design': 'PD-BIM',
  'ASNT NDT LEVEL II': 'NDT PACKAGE',
};

// Get short code for a course name, fallback to original
export function courseShortCode(courseName) {
  if (!courseName) return '';
  return COURSE_SHORT_CODES[courseName] || courseName;
}
